module.exports = __webpack_public_path__ + "img/rdp1.358d24b8.jpg";